import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '@core/services/user.service';
import { OutlineStarIconComponent } from '@shared/icons/outline-star-icon.component';
import { PerformanceItemRatingData } from '@features/models/fans/performance-item-ratings/performance-item-rating-data';
import { ProgrammeLocationPerformanceDetails } from '@features/models/events/programme-location-performances/programme-location-performance-details';

@Component({
  selector: 'app-programme-performance-list',
  imports: [CommonModule, OutlineStarIconComponent],
  templateUrl: './programme-performance-list.component.html'
})
export class ProgrammePerformanceListComponent implements OnChanges {

  @Input() programmePerformanceList?: ProgrammeLocationPerformanceDetails[] = [];
  @Input() performanceItemRatingList?: PerformanceItemRatingData[] = [];
  @Output() performanceItemRated = new EventEmitter<PerformanceItemRatingData>();

  public _userService = inject(UserService);

  ngOnChanges(changes: SimpleChanges): void {
      if (
        changes['programmePerformanceList'] ||
        changes['performanceItemRatingList']
      ) {
          this.setRatings();
      }
  }

  private setRatings() {

    if (this.programmePerformanceList && this.performanceItemRatingList) {

      /*this.programmePerformanceList.forEach(programmePerformance => {

        if (programmePerformance.performance?.id) {
          var performanceItemRating = this.performanceItemRatingList!.find(rating => rating.performanceItemId === programmePerformance.performance?.id);
          
        }
      });*/

    }

  }

  /*public getPerformanceRating(performanceId?: string): PerformanceRatingData | undefined {
    return this.performanceRatingList?.find(performanceRating => performanceRating.performanceId == performanceId);
  }

  public ratePerformance(performanceId: string | undefined, rating: string) {
    console.log(performanceId, rating);
    if (this.performanceRatingList && performanceId) {
      var performanceRating = this.getPerformanceRating(performanceId);
      if (performanceRating?.rating !== rating) {

        const changedPerformanceRating: PerformanceRatingData = {
          id: performanceRating?.id,
          performanceId: performanceId,
          rating: rating
        };

        if (performanceRating !== undefined) {
          performanceRating.rating = rating;
        }
        else {
          this.performanceRatingList.push(changedPerformanceRating);
        }

        this.productionDetailsService.setRating(changedPerformanceRating);
      }
    }
  }*/

}
